// extracted by mini-css-extract-plugin
export default {"container":"PromocodesFilters_container__6sfUI"};